<template>
  <div class="mw-panel">
    <split-pane :defaultPercent="propDefaultPercent" split="vertical" v-show="layout.length>0">
      <template slot="paneL" v-if="propDefaultPercent>0">
        <div class="mw-split-left">
          <div class="mw-toolbar mw-toolbar__left" v-if="propShowTreeToolbar">
            <template v-for="i in treeToolbarItem">
              <el-button v-if="!i.hidden" class="tree-button" :id="i.id" :type="i.type?i.type:''" @click="treeToolbarBtnClick(i.$scope,i.func,i)">
                <i :class='i.icon'></i><span v-html="i.label"></span>
              </el-button>
            </template>
          </div>
          <div :class="{'mw-toolbar__body':propShowTreeToolbar,'mw-panel':!propShowTreeToolbar}">
            <mw-tree  :async="true" ajaxType="POST" :checkCallback="checkCallback" :dragEnable="treeConfig.dragEnable?true:false"
                     :expandedFirst="propTreeExpandFirst" :applicationId="applicationId" :selectFirst="true" :selectNode="selectNodeId"
                     :treeData="treeConfig.treeData"  :paramsAnalyze="treeConfig.paramsAnalyze" @changed="treeConfig.changed" @ready="treeConfig.ready"
                      :url="treeConfig.url" :autoLoad="undefined==treeConfig.autoLoad?true:treeConfig.autoLoad" ref="tree" @dataFilter="treeConfig.dataFilter"
                      v-if="treeConfig !=undefined">
            </mw-tree>
          </div>
        </div>
      </template>
      <template slot="paneR">
        <div class="mw-split-right ">
          <div class="mw-toolbar"  v-if="propShowToolbar">
            <div class="mw__title pull-left" v-if="propToolbarTitle?true:false" :style="{width:propToolbarTitleWidth+'px'}">
              <h5 v-html="propToolbarTitle"></h5>
            </div>
            <div :class="{'mw__body':propToolbarTitle?true:false,'pull-left':propToolbarTitle?true:false}" :style="{width:(propToolbarTitle?('calc(100% - '+ propToolbarTitleWidth+'px)'):'100%')}">
              <div class="mw__body__menu pull-left" :style="{width:(menuItems.length>1 ? propMenuItemWidth:200)+'px'}"
                   v-if="menuItems.length>1 || (menuItems.length==1 && oneItemShowTopbar && oneMenuShowTab)?true:false">
                <el-menu :default-active="defaultKey" mode="horizontal" @select="_handleSelect">
                  <el-menu-item :index="i.key" :key="i.key" v-for="i in menuItems" v-if="!i.hidden">{{i.label}}
                    <span  class="badge badge-danger" v-html="sumData[i.sumKey]" v-if="i.sumKey"></span>
                  </el-menu-item>
                </el-menu>
              </div>
              <div :class="{'pull-left':menuItems.length>1 || (menuItems.length==1 && oneItemShowTopbar && oneMenuShowTab)?true:false}"
                   :style="{width:menuItems.length>1?'calc(100% - '+ propMenuItemWidth+'px)': (menuItems.length==1 && oneItemShowTopbar && oneMenuShowTab) ? 'calc(100% - 200px)':'100%'}">
                <el-row>
                <el-col :span="item.span" :offset="item.offset?item.offset:0" :key="$index"
                        v-if="item.span?true:false"
                        v-for="(item,$index) in layoutGroupItem"  :style="item.style ? item.style+' height:50px;':'height:50px;'">
                  <template v-if="item.type=='button'">
                    <template v-if="item.prefixSlot!=undefined">
                      <slot :name="item.prefixSlot"></slot>
                    </template>
                    <template v-for="(i,$index) in item.items">
                      <el-button :key="$index" v-if="!i.sumKey" :type="i.type?i.type:''"
                                 @click="toolbarBtnClick(i.$scope,i.func,i,$event)">
                        <i :class='i.icon'></i><span v-html="i.label"></span>
                      </el-button>
                      <el-badge :value="btnSumData[i.sumKey]" v-if="i.sumKey">
                        <el-button :key="$index" :type="i.type?i.type:''"
                                   @click="toolbarBtnClick(i.$scope,i.func,i,$event)">
                          <i :class='i.icon'></i><span v-html="i.label"></span>
                        </el-button>
                      </el-badge>
                    </template>
                    <template v-if="item.suffixSlot!=undefined">
                      <slot :name="item.suffixSlot"></slot>
                    </template>
                  </template>
                  <template v-else-if="item.type=='searchText'">
                    <div style="padding-top:8px;line-height:30px;"><!-- :clearable="true" ie11有的浏览器会导致崩溃 -->
                      <el-input :placeholder="$lang(item.tip?item.tip:'名称')"  v-model="filters[item.name]" @keyup.enter.native.prevent="searchText">
                        <el-button v-waves slot="append" type="primary" @click="searchText" >{{$lang('查询')}}</el-button>
                      </el-input>
                    </div>
                  </template>
                  <template v-else-if="item.type=='custom'">
                    <div style="padding-top:8px;line-height:30px;"  ref="toolbarCustomArea" toolbar_custom_area="true">
                    </div>
                  </template>
                  <template v-else-if="item.type=='searchBox'">
                    <el-popover
                      placement="bottom"
                      popper-class="mw-toolbar-popover"
                      width="500"
                      trigger="click">
                      <div class="mw__body">
                        <el-form label-width="100px">
                          <template v-for="f in item.fields">
                            <template v-if="f.type=='date'">
                              <el-form-item :label="f.label+' :'">
                                <el-col :span="4">
                                  {{$lang("全部")}}
                                </el-col>
                                <el-col :span="16">
                                  <el-date-picker
                                    align="right"
                                    type="year"

                                    placeholder="选择年">
                                  </el-date-picker>
                                </el-col>
                              </el-form-item>
                            </template>
                            <template v-else-if="f.type=='single'">
                              <el-form-item :label="f.label+' :'">
                                <el-col :span="4">
                                  <span @click="_wholeClick(f)">{{$lang("全部")}}</span>
                                </el-col>
                                <el-col :span="16">
                                  <template v-for="t in f.items">
                                    <el-col :span="6">
                                      <span v-html="t.label"></span>
                                    </el-col>
                                  </template>
                                </el-col>
                              </el-form-item>
                            </template>
                          </template>
                        </el-form>
                      </div>
                      <el-button slot="reference" class="search-box"><i class='fa fa-list-ul'></i>{{$lang("筛选条件")}}</el-button>
                    </el-popover>
                  </template>
                  <template v-else-if="item.type=='slot'">
                    <slot :name="item.name"></slot>
                  </template>
                  <!-- <template v-if="item.type=='menu' && layout.length>1">
                     <el-menu :default-active="defaultKey" mode="horizontal" @select="_handleSelect">
                       <el-menu-item :index="i.key" :key="i.key" v-for="i in menuItems" >{{i.label}}<span class="badge badge-danger" v-html="sumData[i.sumKey]" v-if="i.sumKey"></span></el-menu-item>
                     </el-menu>
                   </template>-->
                </el-col>
                </el-row>
              </div>
            </div>
            <div class="mw-more" v-if="morePath || moreFn?true:false">
              <el-button @click="_more()">更多</el-button>
            </div>
          </div>
          <div :class="{'mw-toolbar__body':propShowToolbar,'mw-panel':!propShowToolbar}">
            <mw-inner-page ref="dataPage" :params="defaultParams"  v-if="compType=='page' && pageCompId"  noWrap   :pageId="pageCompId"></mw-inner-page>
            <mw-table v-else ref="dataTable" :defaultParams="defaultParams" :showHeader="propShowHeader" :columns="columns"
                      :singleSelect="singleSelect" :currentKey="currentKey" :defaultSort="defaultSort"
                      :border="propBorder" :autoLoad="false" @params-change="_paramsChange" :pagination="propPagination"
                      :noPaginationLimit="propNoPaginationLimit" :data="dataList" :allowLoaded="allowLoaded" :nowrap="nowrap"
                      :api="api" :customCondition="customCondition" :readerAuthorize="readerAuthorize" @rowStyle="rowStyle"
                      :showRowExpander="showRowExpander" :defaultExpandAll="isDefaultExpandAll" @sortableUpdate="sortableUpdate"
                      @rendered="rendered" :extCustomCondition="extCustomCondition" @rowExpanded="rowExpanded" @dataLoaded="dataLoaded"
                      :unitFilter="propUnitFilter" :applicationId="applicationId" :deptFilter="propDeptFilter">
                 <template :slot="item.slotName" slot-scope="{scope}" v-for="(item,index) in columns" v-if="undefined !=item.slotName" >
                  <slot :name="item.slotName"  :scope="scope"  :row="scope.row" :column="scope.column" :$index="scope.$index"></slot>
                </template>
            </mw-table>
          </div>
        </div>
      </template>
    </split-pane>
  </div>
</template>
<script>
  import MwTemplate from "../table/template.vue";

  export default {
    components: {MwTemplate},
    name: 'ToolbarTable',
    props: {
      layout: Array,

      autoLoad: {  //是否自动加载数据
        type: Boolean,
        default: true
      },
      toolbarTitle: {  //标题
        type: String
      },
      showToolbar: {  //是否显示工具条
        type: Boolean,
        default: true
      },
      showTreeToolbar:{  //是否显示工具条
        type: Boolean,
        default: true
      },
      pagination: {  //是否分页
        type: Boolean,
        default: true
      },
      noPaginationLimit: {  //不分页的记录数
        type: Number
      },
      defaultPercent: {
        type: Number,
        default: 0
      },
      border: {
        type: Boolean,
        default: true
      },
      showHeader: {  //是否显示表头
        type: Boolean,
        default: true
      },
      menuItemWidth:{
        type: Number,
        default: 300
      },
      toolbarTitleWidth:{
        type: Number,
        default: 120
      },
      applicationId:{  //应用ID
        type:String
      },
      unitFilter:{  //单位过滤
        type: Boolean,
        default: false
      },
      deptFilter:{  //部门过滤
        type: Boolean,
        default: false
      },
      treeExpandFirst:{
        type: Boolean,
        default: true
      },
      oneMenuShowTab:{
        type: Boolean,
        default: true
      }
    },
    data() {window.toolbarTable=this;
      return {
        propAutoLoad: this.autoLoad,
        oneItemShowTopbar:false,
        propToolbarTitle: this.toolbarTitle,
        propPagination: this.pagination,
        selectNodeId:'',
        propNoPaginationLimit: this.noPaginationLimit,
        propDefaultPercent: this.defaultPercent,
        propShowToolbar:this.showToolbar,
        propShowTreeToolbar:this.showTreeToolbar,
        propBorder: this.border,
        propShowHeader: this.showHeader,
        propMenuItemWidth: this.menuItemWidth,
        propToolbarTitleWidth: this.toolbarTitleWidth,
        propTreeExpandFirst:this.treeExpandFirst,

        propUnitFilter:this.unitFilter,
        propDeptFilter:this.deptFilter,
        allowLoaded:true,

        readerAuthorize:'',

        customCondition:undefined,
        extCustomCondition:undefined,//脚本传入
        expanderDataType:undefined,
        showRowExpander:false,
        isDefaultExpandAll: false,// 默认展开所有
        treeToolbarItem: [],
        treeConfig: undefined,
        toolbarItem:[],

        filters: {},

        layoutGroup: {},
        layoutGroupItem: [],
        isCommonSearch:false,//是否普通检索
        menuItems: [],
        currentMenu: {},
        defaultKey: '',
        currentKey: '',
        defaultSort: [],

        searchFields: {},
        compType:'view',
        pageCompId:'',
        columns: [],
        nowrap:true,
        defaultParams: {},
        singleSelect: false,
        morePath: '', //更多路径
        moreFn:'',    //更多函数
        api: '',
        dataList: [],
        sumData: {},
        btnSumData: {},
        menuSumApi: '',
        menuSumParams:{},
        btnSumApi: {},
        treeFlag:false,
        treeNodeFields:[],
        searchCurNode:false,
        searchKey:'',
        isSearch:false,
        beforeSearchParams:{},
        checkCallback: function (operation, node, node_parent, node_position, more) {
          let result = {};
          this.$emit("checkCallback",operation, node, node_parent, node_position, more,result);
          return result.ret === false ? false : true;
        },
        defaultParamsChange: false,
      }
    },

    mounted() {
      if(this.layout.length>0){
        this._loadLayout();
        this._setTableConfig(this.defaultKey);
      }
    },
    watch: {
      toolbarTitle(v){
        this.propToolbarTitle=v;
      },
      layout() {
        this._loadLayout();
        this._setTableConfig(this.defaultKey);
      }
    },
    methods: {
      rowExpanded(row,container){
        this.$emit("rowExpanded",row,container);
      },
      rowStyle(row,index,ret){
        this.$emit("rowStyle",row,index,ret);
      },
      rendered(dataList,el){
        this.$emit("rendered",dataList,el);
      },
      dataLoaded(dataList,totalSize){
        this.$emit("dataLoaded",dataList,totalSize);
      },
      treeToolbarBtnClick($scope,func,item){
        let me=this;
        if(item.action && item.dealwithWay=="1"){
           PF.action[item.action].call(me,me.mwRef('tree').getSelected(),me.currentKey)
        }else{
          if($scope)
            func.call($scope,me.mwRef('tree').getSelected(),me._getMe(),me.currentKey)
          else
            func(me.mwRef('tree').getSelected(),me._getMe(),me.currentKey)
        }
      },
      toolbarBtnClick($scope,func,item,$event){
        let me=this;
        let selDatas = [];
        let dataTable = me.mwRef('dataTable');
        if(dataTable){
          selDatas = dataTable.getMultipleSelection();
        }
        if(item.action && item.dealwithWay=="1"){
           PF.action[item.action].call(me,selDatas,me.currentKey,$event)
        }else{
          if($scope)
            func.call($scope,selDatas,me._getMe(),me.currentKey,$event)
          else
            func(selDatas,me._getMe(),me.currentKey,$event)
        }
      },
      toggleRowSelection(row,selected){
        this.mwRef('dataTable').toggleRowSelection(row,selected);
      },
      refreshTableDataList(dataList,callback) {
        this.mwRef("dataTable").setData(dataList,callback);
      },

      refreshTable() {
        let me = this;
        if(this.treeFlag){
          let treeObj = this.mwRef("tree");
          let dataList=me.mwRef("dataTable").dataList;
          if(dataList)
            dataList.splice(0,dataList.length);
          treeObj.refresh(); //树刷新会自动加载表格数据的
        }else{
          me.mwRef("dataTable").refresh();
        }
      },
      searchText() {
        let me = this;
        me.isCommonSearch=true;
        if(!me.filters[me.searchKey]){
          if(!$.isEmptyObject(me.beforeSearchParams)){
            for(var k in me.beforeSearchParams){
              me.defaultParams.condition[k] = me.beforeSearchParams[k];
            }
          }
            me.isSearch = false;
        }else{
          me.isSearch = true;
          if(me.searchCurNode===false && me.treeNodeFields.length > 0){
            $.each(me.treeNodeFields,function(i,f){
              me.beforeSearchParams[f] = me.defaultParams.condition[f];
              delete me.defaultParams.condition[f];
            })
          }
        }
        let searchCon={};
        let keys=_.keys(this.filters);
        keys.forEach(v=>{
          let k=v.split("|");
          if(k.length>0){
             k.forEach(v1=>{
               searchCon[v1]=this.filters[v];
             })
          }else{
            searchCon[k]=this.filters[v];
          }
        })
        this.$emit("doSearchText", searchCon);
        if(searchCon.returnFalse===false) return;
        this.mwRef("dataTable").search(searchCon);
      },
      refreshMenuSum() {
        let me = this;
        let para = me.menuSumParams;
        if(!me.menuSumApi.startsWith("/")){
          if(me.menuSumApi.startsWith("#")){//内部service
            eval("PF.invokeInner('" + me.menuSumApi.substring(1) + "',para)").then((data) =>
            {
              let d = data.result;
              me.$emit("setViewSum",d,me.layout);
              for (var key in me.sumData) {
                if (me.sumData[key] != undefined) {
                  if (d[key] == 0) {
                    me.sumData[key] = ''
                  } else {
                    me.sumData[key] = d[key];
                  }
                }
              }
            });
          }else{
            eval('this.mwApi.' + me.menuSumApi + '(para)').then((data) =>
            {
              let d = data.result;
              me.$emit("setViewSum",d,me.layout);
              for (var key in me.sumData) {
                if (me.sumData[key] != undefined) {
                  if (d[key] == 0) {
                    me.sumData[key] = ''
                  } else {
                    me.sumData[key] = d[key];
                  }
                }
              }
            });
          }
        }else{
          //公用service
          eval("PF.invoke('" + me.menuSumApi.substring(1) + "',para)").then((data) =>
          {
            let d = data.result;
            me.$emit("setViewSum",d,me.layout);
            for (var key in me.sumData) {
              if (me.sumData[key] != undefined) {
                if (d[key] == 0) {
                  me.sumData[key] = ''
                } else {
                  me.sumData[key] = d[key];
                }
              }
            }
          });
        }
      },
      refreshBtnSum(sumKey, key) {
        let me = this, para = {};
        let qp = me.btnSumApi[sumKey+"___sumDefaultParams"];
        if(qp && _.isObject(qp)){
          para = qp;
        }
        if (key) {
          para.key = key;
        } else {
          me.currentKey;
        }
        if(!me.btnSumApi[sumKey].startsWith("/")){
          if(me.btnSumApi[sumKey].startsWith("#")){//内部service
            eval("PF.invokeInner('" + me.btnSumApi[sumKey].substring(1) + "',para)").then((data) =>
            {
              let d = data.result;
              if (d == 0) {
                me.btnSumData[sumKey] = ""
              } else {
                me.btnSumData[sumKey] = d
              }
            });
          }else{
            eval('this.mwApi.' + me.btnSumApi[sumKey] + '(para)').then((data) =>
            {
              let d = data.result;
              if (d == 0) {
                me.btnSumData[sumKey] = ""
              } else {
                me.btnSumData[sumKey] = d
              }
            });
          }
        }else{
          //公用service
          eval("PF.invoke('" + me.btnSumApi[sumKey].substring(1) + "',para)").then((data) =>
          {
            let d = data.result;
            if (d == 0) {
              me.btnSumData[sumKey] = ""
            } else {
              me.btnSumData[sumKey] = d
            }
          });
        }
      },
      refreshTableDefaultParams(params) {
        this.beforeSearchParams={};
        this.defaultParamsChange = true;
        this.defaultParams = params;
      },
      _refreshTable() {
        this.mwRef("dataTable").refresh();
      },

      clearSelection(){
         this.mwRef("dataTable").clearSelection();
      },

      clearFilters(){
        let keys=this.mwLodash.keys(this.filters);
        keys.forEach(v=>{
          this.$set(this.filters, v, '')
        })
      },
      _paramsChange(params) {
        this.clearFilters();
        if (this.defaultParamsChange) {
          this._refreshTable();
        } else {
          this.defaultParamsChange = false;
        }
      },
      getMultipleSelection() {
        return this.mwRef('dataTable').getMultipleSelection();
      },
      _getMe() {
        let me = this;
        return {
          mwMsg: me.mwMsg.bind(me),
          mwConfirm: me.mwConfirm.bind(me),
          mwApi: me.mwApi,
          mwUtil: me.mwUtil,
          mwConfig: me.mwConfig,
          refreshTable: me.refreshTable,
          refreshMenuSum: me.refreshMenuSum,
          refreshBtnSum: me.refreshBtnSum
        };
      },
      _loadLayout() {
        let me = this, defaultKey = '', menuItems = [];
        let layoutGroup = {};

        me.layout.forEach(function (item) {
          let key = '';
          item.forEach(function (it) {
            if (it.type == 'menu') {
              menuItems.push(it);
              key = it.key ? it.key : 'default';
              if (!defaultKey) {
                defaultKey = it.defaultActive ? key : '';
              }
            }else if(it.type=="searchText"){
              if(it.searchCurNode){
                 me.searchCurNode = true;
              }
              if(it.name){
                me.searchKey = it.name;
              }
            }
          })
          layoutGroup[key] = item;
        })

        if (!defaultKey) {
          defaultKey = 'default';
        }
        me._setSumDataConfig(menuItems);
        me.layoutGroup = layoutGroup;
        me.menuItems = menuItems;

        me.defaultKey = defaultKey;
      },
      _setSumDataConfig(menuItems) {
        let me = this;
        menuItems.forEach(function (item) {
          if (item.sumKey) {
            //me.sumData[item.sumKey]='';
            me.$set(me.sumData, item.sumKey, '')
          }
          if (item.sumApi) {
            me.menuSumApi = item.sumApi;
            if(item.sumParams){
              me.menuSumParams = item.sumParams;
            }
          }
        });

      },
      transColumn(columns) {
        if(!columns)return [];
        return columns.map(col=>{
          if (window.$lang) {
            let newCol = {...col};
            newCol.label = $lang(col.label);
            return newCol;
          } else {
            return col;
          }
        })
      },
      _setTableConfig(key) {
        let me = this;
        me.layoutGroupItem = me.layoutGroup[key];
        me.btnSumApi = {};
        me.btnSumData = {};
        me.searchFields = {};
        me.treeFlag=false;
        me.layoutGroupItem.forEach(function (item) {
          if (item.type == 'menu') {
            if(item.pagination != undefined){
              me.propPagination=item.pagination;
              me.propNoPaginationLimit=item.noPaginationLimit;
            }
            if(item.toolbar != undefined){
              me.propShowToolbar=item.toolbar;
            }
            if(me.compType=="page" && item.compType != "page"){
              //页面切换到视图中没有去请求数据
              me.$nextTick(function(){
                me._refreshTable();
              })
            }
            me.compType = (item.compType || "view")
            me.pageCompId = item.pageCompId || "";
            if (item.defaultPercent != undefined && item.defaultPercent>0) {
              me.allowLoaded=false;
              me.propDefaultPercent = item.defaultPercent;
              if(item.treeToolbarItem){
                item.treeToolbarItem.forEach(it=>it.label=$lang(it.label))
                me.treeToolbarItem=item.treeToolbarItem;
              }

              if(item.treeConfig){
                me.treeConfig=item.treeConfig;
              }
              if(item.toolbarItem)
                me.toolbarItem=item.toolbarItem;
              me.treeFlag=true;
            }else{
              me.propDefaultPercent=0;
            }
          }
          if (item.type == 'button') {
            item.items.forEach(function (it) {
              it.label=$lang(it.label);
              if (it.sumKey && it.sumApi) {
                me.btnSumApi[it.sumKey] = it.sumApi;
                me.$set(me.btnSumData, it.sumKey, '')
                me.btnSumApi[it.sumKey+"___sumDefaultParams"] = it.sumParams;
                me.refreshBtnSum(it.sumKey, key,it.sumParams)
              }
            })
          }
          if (item.type == 'searchText') {
            if (item.name != '') {
              me.$set(me.filters,item.name ? item.name : 'title', '')
            }
          }
          if (item.type == 'searchBox') {
            item.fields.forEach(function (it) {
              if (it.type == 'date' || it.type == 'single') {
                me.searchFields[it.name] = '';
              }
            })
          }
        })
        me.menuItems.forEach(function (item) {
          if (item.key == key || me.menuItems.length == 1) {
            me.columns = me.transColumn(item.columns);
            me.nowrap = item.nowrap;
            if (item.defaultParams) {
              me.defaultParams = item.defaultParams;
            } else {
              me.defaultParams = {}
            }
            if (item.morePath) {
              me.morePath = item.morePath;
              me.moreFn = "";
            }else if(item.moreFn){
              me.moreFn = item.moreFn;
              me.morePath = "";
            } else {
              me.morePath = '';
              me.moreFn = '';
            }

            if (item.defaultSort) {
              me.defaultSort = item.defaultSort;
            } else {
              me.defaultSort = []
            }

            if (item.api)
              me.api = item.api;
            else
              me.dataList = item.dataList || [];

        /*    if(item.unitFilter != undefined) {
              me.propUnitFilter = item.unitFilter
            }else{*/
              me.propUnitFilter=item.unitFilter
            //}

        /*    if(item.deptFilter != undefined) {
              me.propDeptFilter = item.deptFilter
            }else{*/
              me.propDeptFilter=item.deptFilter
            //}
            me.readerAuthorize=item.readerAuthorize
            me.customCondition=item.customCondition
            me.extCustomCondition=item.extCustomCondition
            //me.expanderDataType=item.expanderDataType

            me.showRowExpander=item.showRowExpander;
            me.isDefaultExpandAll = !!item.isDefaultExpandAll;
            me.singleSelect = item.singleSelect ? item.singleSelect : false;

            if (me.autoLoad && !me.treeFlag) {
              me.currentKey = key;
            }
            return;
          }
        })
        if (me.menuSumApi) {
          me.refreshMenuSum();
        }
        me.afterChangeTab(key);
      },
      _more() {
        let me = this;
        if(me.morePath){
           me.$router.push({path: me.morePath,query:{key:this.currentKey}})
        }else if(me.moreFn){
          var fn = new Function("return "+me.moreFn)();
          fn.call(me.$parent,me);
        }
      },
      _wholeClick(filed) {
        let me = this;
      },
      // 得到当前菜单的defult-active
      getCurrentKey(){
        return this.currentKey;
      },
      afterChangeTab(key){
        this.$emit("afterChangeTab", key);
      },
      sortableUpdate(changes) {
        this.$emit("sortableUpdate",changes);
      },
      _handleSelect(key) {
        this._setTableConfig(key);
      }/*,
      rowDblClick(row, event){
        this.$emit('row-dblclick', row, event,this.currentKey);
      }*/
    }
  }
</script>



// WEBPACK FOOTER //
// src/common/components/extend/toolbar-table/index.vue